<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side
          side-nav(
            v-bind:sideNavData="sideNavData"
          )
        .profile-page__main
          .profile-page__header
            .profile-page__title
              h1.title Настройки аккаунта
          .profile-page__body
            .profile-page-form
              .profile-page-form__section-container
                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Пароль
                  .profile-section__body
                    form
                      password-change-form
                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title E-mail
                  .profile-section__body
                    form
                      login-change-form
    .page__footer
      main-footer
</template>
<script>
import SideNav from "@/components/sideNav/SideNav";
import MainFooter from "@/components/footer/Footer";
import PasswordChangeForm from "../../../../components/password-change-form/PasswordChangeForm";
import LoginChangeForm from "../../../../components/login-change-form/LoginChangeForm";

export default {
  name: "Settings",
  components: {
    LoginChangeForm,
    PasswordChangeForm,
    SideNav,
    MainFooter
  },
  props: ["sideNavData"],
  methods: {}
};
</script>
